import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createProvincesSlice = (set, get) => ({
    provinces: {
        loading: false,
        data: [],
    },
    getProvinces: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ provinces: { ...state.provinces, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: '/v1/business/province',
                headers: { token }
            });
            set(state => ({ provinces: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ provinces: { ...state.provinces, loading: false } }));
        }
    }
});
